module.exports = __webpack_public_path__ + "static/img/bgc2.8b1a444a.jpg";